import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const PdpTypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Text ta={'center'}>{rowData.pdpContext?.pdpType}</Text>
        </Box>
    );
};

const PdpTypeColumn = () => ({
    accessorKey: 'pdpcontext.type',
    header: 'PDP Type',
    size: 1,
    Cell: ({ cell }) => <PdpTypeCell cell={cell} />,
});
export default PdpTypeColumn;
